import { DocumentRequest } from '@models/document-requests';

export class Create {
	static readonly type = '[DocumentRequests] Create';
	constructor(public payload: DocumentRequest) {}
}

export class Update {
	static readonly type = '[DocumentRequests] Update';
	constructor(public payload: DocumentRequest) {}
}

export class Delete {
	static readonly type = '[DocumentRequests] Delete';
	constructor(public payload: string) {}
}
